var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 48,
    viewBox: "0 0 30 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b14f6c;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shopping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_pin_fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.32,4.91A14.6,14.6,0,1,0,4.67,25.56S15,35.68,15,47.37c0-11.68,10.33-21.8,10.33-21.8A14.6,14.6,0,0,0,25.32,4.91Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.89,7.83a1.87,1.87,0,0,0,2-1.65,1.82,1.82,0,0,0-1.73-1.94,1.86,1.86,0,0,0-2,1.65A1.83,1.83,0,0,0,15.89,7.83Zm7.78,14.51L23,16.91H22a4.27,4.27,0,0,0,0-.78c0-.28-.12-.49-.26-.55a.78.78,0,0,0,.21-.47.8.8,0,0,0-.33-.71L19,12.69,17.11,9.1a2,2,0,0,0-1.5-.9,2.14,2.14,0,0,0-1.32.37L10.5,11.5a.75.75,0,0,0-.26.39l-.88,3.55-.07.11h0a.4.4,0,0,0-.33.33,2.6,2.6,0,0,0-.11.62v.41h-1l-.63,5.43H9.76L8.65,24.12a1.44,1.44,0,0,0-.17.52A1.24,1.24,0,0,0,9.65,26a1.33,1.33,0,0,0,1.2-.6l1.88-3H13l0-.33.52-.84a2.72,2.72,0,0,0,.26-.52l.64-2.76,2.72,2.84L17.92,25a1.29,1.29,0,0,0,1.15,1,1.26,1.26,0,0,0,1.38-1.12v-.25L20,22.33ZM9.27,16.45c0-.21.11-.34.25-.34h.05a.85.85,0,0,0,1.3,0,.31.31,0,0,1,.09.15,1.53,1.53,0,0,1,.06.4,2,2,0,0,1,0,.22H9.26A3.53,3.53,0,0,1,9.27,16.45Zm2.59.46h-.54a4.3,4.3,0,0,0,0-.78.8.8,0,0,0-.2-.51l.67-2.91,1.32-1Zm9.84,0H20a3.14,3.14,0,0,1,0-.46c0-.21.1-.34.25-.34h1.22c.11,0,.18.06.22.19a1.47,1.47,0,0,1,.06.4Zm-5.68-1,.85-3.59.72,1.35a.92.92,0,0,0,.21.24l2.55,1.68H20c-.15,0-.2.14-.25.33a2.64,2.64,0,0,0,0,.62v.41H18.55l-.19,1.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.84ad8ca072ec81b0a0ac9f1a28a492f9.svg";
export { ForwardRef as ReactComponent };